import React from 'react'

const Total = (props) => {
    const { total, label } = props
    return (
        <div className="pagination-total">
            Total <span>{total}</span> {label || "Items"}
        </div>
    )
}

export default Total
